import constants from "Constants";

export function Image({ src, alt }: { src: string; alt: string }) {
  return (
    <div className="d-flex mb-4 w-100 justify-content-center">
      <img className="w-100" src={src} alt={alt} style={{ maxWidth: constants.contentWidth }} />
    </div>
  );
}
